import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import { connect } from "react-redux";
import { firestore } from "../../firebase/firebase.utils";

const STATUS_COLORS = {
  Processing:        { bg: "#F3F0FF", color: "#6C63FF" },
  Confirmed:         { bg: "#EFF6FF", color: "#2563EB" },
  Packing:           { bg: "#FFF7ED", color: "#C2410C" },
  "On the way":      { bg: "#F0FDF4", color: "#15803D" },
  Delivered:         { bg: "#DCFCE7", color: "#166534" },
  "Partial Delivered":{ bg: "#ECFDF5", color: "#047857" },
  Cancelled:         { bg: "#FEF2F2", color: "#B91C1C" },
  Paid:              { bg: "#DCFCE7", color: "#166534" },
  Pending:           { bg: "#FEF9C3", color: "#92400E" },
};

function StatusBadge({ status }) {
  const s = STATUS_COLORS[status] || { bg: "#F3F4F6", color: "#6B7280" };
  return (
    <span
      style={{
        background: s.bg,
        color: s.color,
        borderRadius: 4,
        padding: "3px 10px",
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {status || "—"}
    </span>
  );
}

function Spinner() {
  return (
    <div style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}>
      Loading...
    </div>
  );
}

const TABS = ["orders", "preorders", "addresses"];
const TAB_LABELS = { orders: "Orders", preorders: "Pre-orders", addresses: "Shipping Addresses" };

export class DetailUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "orders",
      orders: [],
      preOrders: [],
      ordersLoading: true,
      preOrdersLoading: true,
    };
  }

  componentDidMount = async () => {
    const userId = this.props.match.params.userId;
    this.fetchOrders(userId);
    this.fetchPreOrders(userId);
  };

  fetchOrders = async (userId) => {
    try {
      const snap = await firestore
        .collection("orders")
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc")
        .limit(20)
        .get();
      const orders = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      this.setState({ orders, ordersLoading: false });
    } catch (e) {
      console.error("Orders fetch error:", e);
      this.setState({ ordersLoading: false });
    }
  };

  fetchPreOrders = async (userId) => {
    try {
      const snap = await firestore
        .collection("bookingRequest")
        .where("userId", "==", userId)
        .orderBy("time", "desc")
        .limit(20)
        .get();
      const preOrders = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      this.setState({ preOrders, preOrdersLoading: false });
    } catch (e) {
      console.error("Pre-orders fetch error:", e);
      this.setState({ preOrdersLoading: false });
    }
  };

  formatDate(createdAt) {
    if (!createdAt) return "—";
    const secs = createdAt.seconds || createdAt._seconds;
    if (!secs) return "—";
    return new Date(secs * 1000).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  formatJoinDate(createdAt) {
    if (!createdAt) return "—";
    const secs = createdAt.seconds || createdAt._seconds;
    if (!secs) return "—";
    return new Date(secs * 1000).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  render() {
    const { user } = this.props;
    const { activeTab, orders, preOrders, ordersLoading, preOrdersLoading } = this.state;

    const addresses = (() => {
      if (!user || !user.address) return [];
      if (Array.isArray(user.address)) return user.address;
      return [];
    })();

    const initial = user && user.displayName
      ? user.displayName.charAt(0).toUpperCase()
      : "?";

    return (
      <Fragment>
        <Breadcrumb title={user ? user.displayName : "User Detail"} parent="Users" />
        <div className="container-fluid">

          {/* Profile Card */}
          <div
            className="card"
            style={{
              marginBottom: 24,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              border: "1px solid #F0F0F0",
            }}
          >
            <div className="card-body" style={{ padding: 28 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
                {/* Avatar */}
                <div style={{ flexShrink: 0 }}>
                  {user && user.imageUrl ? (
                    <img
                      src={user.imageUrl}
                      alt={initial}
                      style={{ width: 80, height: 80, borderRadius: "50%", objectFit: "cover" }}
                      referrerPolicy="no-referrer"
                    />
                  ) : (
                    <div
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        background: "#6C63FF",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 32,
                        fontWeight: 700,
                      }}
                    >
                      {initial}
                    </div>
                  )}
                </div>

                {/* Info */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: "#1A1A2E", marginBottom: 6 }}>
                    {user ? user.displayName : "—"}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 24px" }}>
                    {[
                      { label: "Mobile", value: user ? (user.mobileNo || user.mobileNumber || "—") : "—" },
                      { label: "Email", value: user ? user.email || "—" : "—" },
                      { label: "Joined", value: user ? this.formatJoinDate(user.createdAt) : "—" },
                    ].map(({ label, value }) => (
                      <div key={label} style={{ fontSize: 13, color: "#555" }}>
                        <span style={{ color: "#AAA", marginRight: 4 }}>{label}:</span>
                        <span style={{ fontWeight: 500, color: "#333" }}>{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tab bar */}
          <div
            className="card"
            style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.08)", border: "1px solid #F0F0F0" }}
          >
            {/* Tab headers */}
            <div style={{ display: "flex", borderBottom: "1px solid #EFEFEF", padding: "0 20px" }}>
              {TABS.map((tab) => {
                const isActive = activeTab === tab;
                const count =
                  tab === "orders" ? orders.length
                  : tab === "preorders" ? preOrders.length
                  : addresses.length;
                return (
                  <button
                    key={tab}
                    onClick={() => this.setState({ activeTab: tab })}
                    style={{
                      padding: "14px 20px",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      fontSize: 14,
                      fontWeight: isActive ? 700 : 500,
                      color: isActive ? "#6C63FF" : "#888",
                      borderBottom: isActive ? "2px solid #6C63FF" : "2px solid transparent",
                      marginBottom: -1,
                      display: "flex",
                      alignItems: "center",
                      gap: 7,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {TAB_LABELS[tab]}
                    <span
                      style={{
                        background: isActive ? "#F3F0FF" : "#F3F4F6",
                        color: isActive ? "#6C63FF" : "#999",
                        borderRadius: 20,
                        padding: "1px 8px",
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {count}
                    </span>
                  </button>
                );
              })}
            </div>

            {/* Tab panels */}
            <div className="card-body" style={{ padding: 0 }}>

              {/* Orders */}
              {activeTab === "orders" && (
                ordersLoading ? (
                  <Spinner />
                ) : orders.length === 0 ? (
                  <div style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}>
                    No orders found
                  </div>
                ) : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#F8F7FF", borderBottom: "2px solid #EEE" }}>
                        {["Order ID", "Date", "Total Bill", "Status"].map((h) => (
                          <th key={h} style={{ padding: "10px 16px", fontSize: 12, fontWeight: 600, color: "#6C63FF", textAlign: "left", whiteSpace: "nowrap" }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map((order) => (
                        <tr key={order.id} style={{ borderBottom: "1px solid #F3F3F3" }}>
                          <td style={{ padding: "10px 16px", fontSize: 13, fontWeight: 600, color: "#6C63FF" }}>#{order.id}</td>
                          <td style={{ padding: "10px 16px", fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>{this.formatDate(order.createdAt)}</td>
                          <td style={{ padding: "10px 16px", fontSize: 13, fontWeight: 600, color: "#222" }}>৳{(order.subTotal || 0) + (order.deliveryCharge || 0) - (order.discountApplied || 0) - (order.couponApplied ? order.couponApplied.discount || 0 : 0) - (order.finalDiscount || 0)}</td>
                          <td style={{ padding: "10px 16px" }}><StatusBadge status={order.orderStatus} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              )}

              {/* Pre-orders */}
              {activeTab === "preorders" && (
                preOrdersLoading ? (
                  <Spinner />
                ) : preOrders.length === 0 ? (
                  <div style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}>
                    No pre-orders found
                  </div>
                ) : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#F8F7FF", borderBottom: "2px solid #EEE" }}>
                        {["Booking ID", "Date", "Status"].map((h) => (
                          <th key={h} style={{ padding: "10px 16px", fontSize: 12, fontWeight: 600, color: "#6C63FF", textAlign: "left", whiteSpace: "nowrap" }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {preOrders.map((booking) => (
                        <tr key={booking.bookingId || booking.id} style={{ borderBottom: "1px solid #F3F3F3" }}>
                          <td style={{ padding: "10px 16px", fontSize: 13, fontWeight: 600, color: "#6C63FF" }}>{booking.bookingId || booking.id}</td>
                          <td style={{ padding: "10px 16px", fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>
                            {booking.time ? new Date(booking.time).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—"}
                          </td>
                          <td style={{ padding: "10px 16px" }}><StatusBadge status={booking.status} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              )}

              {/* Shipping Addresses */}
              {activeTab === "addresses" && (
                addresses.length === 0 ? (
                  <div style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}>
                    No shipping addresses found
                  </div>
                ) : (
                  <div style={{ padding: 20, display: "flex", flexWrap: "wrap", gap: 16 }}>
                    {addresses.map((addr, i) => (
                      <div
                        key={addr.id || i}
                        style={{
                          background: "#FAF7F2",
                          border: "1.5px solid #E8DFD0",
                          borderRadius: 10,
                          padding: "16px 20px",
                          minWidth: 240,
                          maxWidth: 320,
                          flex: "1 1 240px",
                          position: "relative",
                        }}
                      >
                        {addr.defaultShipping && (
                          <span
                            style={{
                              position: "absolute",
                              top: 12,
                              right: 12,
                              background: "#E8DFD0",
                              color: "#5C4A32",
                              fontSize: 10,
                              fontWeight: 700,
                              borderRadius: 4,
                              padding: "2px 7px",
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            Default
                          </span>
                        )}
                        <div style={{ fontWeight: 700, fontSize: 14, color: "#3B2F1E", marginBottom: 6 }}>
                          {addr.fullName || "—"}
                        </div>
                        <div style={{ fontSize: 13, color: "#5C4A32", lineHeight: 1.6 }}>
                          {addr.address && <div>{addr.address}</div>}
                          {(addr.district || addr.division) && (
                            <div>{[addr.district, addr.division].filter(Boolean).join(", ")}</div>
                          )}
                          {addr.mobileNo && (
                            <div style={{ marginTop: 6, color: "#7A6040", fontWeight: 500 }}>
                              {addr.mobileNo}
                            </div>
                          )}
                          {addr.addressType && (
                            <div style={{ marginTop: 4, fontSize: 11, color: "#A8906A", textTransform: "capitalize" }}>
                              {addr.addressType}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              )}

            </div>
          </div>

        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.users.users.find(
      (user) => user.uid === ownProps.match.params.userId
    ),
  };
};

export default connect(mapStateToProps, {})(DetailUser);
